import React from 'react'
import styled from 'styled-components'
import LogoIcon from '../../../assets/img/curvo-logo.png'
import { Flex } from '../../../shared/components/Flex'

const Wrapper = styled(Flex)`
  flex: 1;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
`

const FormWrapper = styled(Flex)`
  width: 600px;
  border: 1px solid #d8e1e8;
  border-radius: 3px;
  padding: 3rem;
  box-sizing: border-box;
`

const LogoBlock = styled.div`
  width: 350px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
`

const FormerLookupTagline = styled.small`
  display: block;
  width: 100%;
  margin-top: 0.5rem;
  font-size: 0.875rem;
  font-style: italic;
  color: #6b7280;
  text-align: right;
`

type Props = {
  children?: React.ReactNode
}

const AuthLayout: React.FC<Props> = ({ children }) => (
  <Wrapper column>
    <Flex marginBottom="3rem" column align="center">
      <LogoBlock>
        <img src={LogoIcon} alt="Curvo Labs Logo" width="350" />
        <FormerLookupTagline>formerly known as Lookup</FormerLookupTagline>
      </LogoBlock>
    </Flex>
    <FormWrapper column>{children}</FormWrapper>
  </Wrapper>
)

export default AuthLayout
